import { emptyObj } from 'util/objects'
import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

export const selectProduct = createBasicSelector(
  selectBase,
  (_state, product) => product,
  (billing, product) => {
    if (['kb', 'inbox'].indexOf(product) === -1)
      throw new Error(`Unknown product '${product}'`)
    return billing[product] || emptyObj
  }
)
